// src/pages/About.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function About() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#9BE7FF] via-[#FDF7FF] to-[#FFE8C7] text-slate-900">
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">
              About Us
            </h1>
            <p className="mt-2 text-slate-800 leading-7 max-w-2xl">
              A magical, story-driven piano journey where kids learn real skills —
              one song at a time.
            </p>
          </div>

          <button
            onClick={() => nav("/home")}
            className="px-4 py-2 rounded-full bg-white/90 border border-slate-200 shadow-sm hover:bg-white"
            style={{ touchAction: "manipulation" }}
          >
            ← Back to Home
          </button>
        </div>

        {/* Main content card */}
        <div className="mt-8 rounded-3xl border bg-white/90 backdrop-blur p-6 shadow-sm">
          <p className="text-slate-800 leading-7">
            <span className="font-extrabold">Piano With Pan</span> (formerly Treble Town)
            is a story-driven piano learning adventure created by Nishat Chadha.
            Kids learn piano through fun levels, melodies, and a magical quest to
            defeat Doron — <span className="font-bold">one song at a time</span>.
          </p>

          <p className="text-slate-800 leading-7 mt-4">
            Our mission is simple:{" "}
            <span className="font-extrabold">Piano for Everyone</span> — making music
            education approachable, playful, and accessible for every child.
          </p>
        </div>

        {/* What you’ll learn */}
        <div className="mt-6 rounded-3xl border bg-white/90 backdrop-blur p-6 shadow-sm">
          <div className="text-xl font-extrabold">What you’ll learn</div>
          <ul className="mt-3 list-disc pl-5 text-slate-700 space-y-2">
            <li>
              White notes + basic music reading (perfect for beginners)
            </li>
            <li>
              10 beginner-friendly songs and patterns that build confidence
            </li>
            <li>
              Timing, focus, and consistency through game-style progress
            </li>
          </ul>
        </div>

        {/* Tiny footer line */}
        <div className="mt-6 text-slate-600 text-sm">
          © {new Date().getFullYear()} Piano With Pan • Piano For Everyone By Nishat Chadha.
        </div>
      </div>
    </div>
  );
}